import React from 'react';
import './TreatmentModalities.css';

const TreatmentModalities = () => {
    return (
        <section className="treatment-modalities-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2>Advanced Treatment Modalities & Technology</h2>
                            <p style={{fontSize: '18px', lineHeight: '1.8', color: '#666', maxWidth: '800px', margin: '0 auto'}}>
                                Our state-of-the-art certified surgery centers feature precision equipment for optimal 
                                cellular preparation and delivery. Each treatment protocol combines multiple regenerative modalities, 
                                tailored to maximize therapeutic outcomes for your specific condition.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-4 col-md-6">
                        <div className="modality-card">
                            <div className="modality-icon">
                                <i className="fas fa-dna"></i>
                            </div>
                            <h3>Advanced Cellular Therapies</h3>
                            <ul className="modality-list">
                                <li>Wharton's Jelly MSCs</li>
                                <li>Exosome Therapies</li>
                                <li>Allogeneic Cellular Concentrates</li>
                                <li>Autologous Cell Concentrates</li>
                                <li>Systemic IV Protocols</li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="modality-card">
                            <div className="modality-icon">
                                <i className="fas fa-microscope"></i>
                            </div>
                            <h3>Precision Orthobiologics</h3>
                            <ul className="modality-list">
                                <li>Enhanced PRP Protocols</li>
                                <li>Bone Marrow Aspirate Concentrate (BMAC)</li>
                                <li>Growth Factor Optimization</li>
                                <li>Cellular Concentrate Therapies</li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="modality-card">
                            <div className="modality-icon">
                                <i className="fas fa-bullseye"></i>
                            </div>
                            <h3>Targeted Interventions</h3>
                            <ul className="modality-list">
                                <li>Image-guided Precision Delivery</li>
                                <li>Advanced Injection Techniques</li>
                                <li>Specialized Delivery Systems</li>
                                <li>Comprehensive Recovery Protocols</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Statistics Section */}
                <div className="row mt-5 pt-4">
                    <div className="col-lg-12">
                        <div className="statistics-box">
                            <div className="stat-item">
                                <i className="fas fa-trophy"></i>
                                <div className="stat-text">
                                    <span className="stat-number">25+ Years</span>
                                    <span className="stat-label">Experience</span>
                                </div>
                            </div>
                            <div className="stat-divider"></div>
                            <div className="stat-item">
                                <i className="fas fa-circle-check"></i>
                                <div className="stat-text">
                                    <span className="stat-number">1000+</span>
                                    <span className="stat-label">Procedures Performed</span>
                                </div>
                            </div>
                            <div className="stat-item">
                                <i className="fas fa-hospital"></i>
                                <div className="stat-text">
                                    <span className="stat-number">Certified</span>
                                    <span className="stat-label">Surgery Centers</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TreatmentModalities;